import { render, staticRenderFns } from "./BusinessInformation.vue?vue&type=template&id=74acb6da"
import script from "./BusinessInformation.vue?vue&type=script&lang=js"
export * from "./BusinessInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports